module.exports = __webpack_public_path__ + "img/renwu4.110c4c3a.png";